/** 落地页 AI 执行池按服务商的并发槽数接口；读取返回已合并默认值的完整配置。 */
import type {
  LandingAiProviderConcurrency,
  UpdateLandingAiProviderConcurrencyRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

const PATH = '/api/v1/model-configurations/provider-concurrency';
export const landingAiProviderConcurrencyApi = {
  get: () => apiRequest<LandingAiProviderConcurrency>({ method: 'GET', path: PATH }),
  update: (body: UpdateLandingAiProviderConcurrencyRequest) =>
    apiRequest<LandingAiProviderConcurrency>({ method: 'PUT', path: PATH, body }),
};
